module.exports = __webpack_public_path__ + "static/media/take_tip_with_blue_bg.059b10b3.svg";